import { useEffect, useState } from 'react';

const API = (process.env.REACT_APP_API_URL || 'http://localhost:8000') + '/api/personel';
const token = () => localStorage.getItem('token');
const hdr = () => ({ 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` });

const SONUC: Record<string, { label: string; renk: string; bg: string; min: number; max: number }> = {
  cok_iyi:   { label: 'Çok İyi',    renk: '#065f46', bg: '#d1fae5', min: 90, max: 100 },
  iyi:       { label: 'İyi',        renk: '#1e40af', bg: '#dbeafe', min: 75, max: 89  },
  orta:      { label: 'Orta',       renk: '#92400e', bg: '#fef3c7', min: 60, max: 74  },
  yetersiz:  { label: 'Yetersiz',   renk: '#991b1b', bg: '#fee2e2', min: 0,  max: 59  },
};

const PUAN_ALANLARI = [
  { key: 'meslek_bilgisi', label: 'Mesleki Bilgi & Beceri', max: 20, aciklama: 'Göreviyle ilgili bilgi düzeyi ve uygulama becerisi' },
  { key: 'is_kalitesi',    label: 'İş Kalitesi',            max: 20, aciklama: 'Doğruluk, titizlik ve işlerin eksiksizliği' },
  { key: 'verimlilik',     label: 'Verimlilik & Üretkenlik', max: 20, aciklama: 'İş miktarı, hız ve kaynakların etkin kullanımı' },
  { key: 'uyum',           label: 'Uyum & İş Birliği',      max: 20, aciklama: 'Ekip çalışması, kurallara uyum, iletişim' },
  { key: 'davranis',       label: 'Davranış & Tutum',        max: 20, aciklama: 'Kuruma bağlılık, etik davranış, disiplin' },
];

const BOŞ_FORM = {
  personel_id: '', yil: new Date().getFullYear(), donem: '',
  degerlendiren_adi: '',
  meslek_bilgisi: 0, is_kalitesi: 0, verimlilik: 0, uyum: 0, davranis: 0,
  degerlendirme_notu: '', itiraz_var: false, itiraz_notu: '',
};

export default function PersonelPerformans() {
  const [liste, setListe] = useState<any[]>([]);
  const [personeller, setPersoneller] = useState<any[]>([]);
  const [form, setForm] = useState<any>(null);
  const [filtre, setFiltre] = useState({ personel_id: '', yil: '' });
  const [istatistik, setIstatistik] = useState<any>({});

  useEffect(() => {
    yukle();
    fetch(`${API}/?durum=aktif`, { headers: hdr() }).then(r => r.json()).then(setPersoneller);
  }, []);

  function yukle(f = filtre) {
    const p = new URLSearchParams();
    if (f.personel_id) p.set('personel_id', f.personel_id);
    if (f.yil)         p.set('yil', f.yil);
    fetch(`${API}/performans/liste?${p}`, { headers: hdr() }).then(r => r.json()).then(data => {
      setListe(data);
      // İstatistik hesapla
      const toplam = data.length;
      const dist: Record<string, number> = {};
      let pTotal = 0;
      data.forEach((d: any) => { dist[d.sonuc] = (dist[d.sonuc] || 0) + 1; pTotal += d.toplam_puan || 0; });
      setIstatistik({ toplam, dist, ort: toplam > 0 ? (pTotal / toplam).toFixed(1) : '—' });
    });
  }

  function filtreDegistir(k: string, v: string) {
    const yeni = { ...filtre, [k]: v };
    setFiltre(yeni);
    yukle(yeni);
  }

  async function kaydet() {
    if (!form.personel_id) return alert('Personel seçiniz');
    const method = form.id ? 'PUT' : 'POST';
    const url = form.id ? `${API}/performans/${form.id}` : `${API}/performans`;
    const veri = { ...form, personel_id: Number(form.personel_id), yil: Number(form.yil) };
    PUAN_ALANLARI.forEach(a => { veri[a.key] = Number(veri[a.key]); });
    await fetch(url, { method, headers: hdr(), body: JSON.stringify(veri) });
    setForm(null);
    yukle();
  }

  const toplamPuan = form ? PUAN_ALANLARI.reduce((s, a) => s + (Number(form[a.key]) || 0), 0) : 0;
  const sonucOtomatik = toplamPuan >= 90 ? 'cok_iyi' : toplamPuan >= 75 ? 'iyi' : toplamPuan >= 60 ? 'orta' : 'yetersiz';

  const yillar = Array.from(new Set(liste.map(i => String(i.yil)))).sort((a, b) => Number(b) - Number(a));

  return (
    <div style={{ padding: 24, fontFamily: 'system-ui, sans-serif' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <div>
          <h2 style={{ margin: 0, fontSize: 22, fontWeight: 700, color: '#111827' }}>Performans Değerlendirme</h2>
          <p style={{ margin: '4px 0 0', fontSize: 13, color: '#6b7280' }}>Yıllık sicil — 5 kriter × 20 puan = 100 tam puan</p>
        </div>
        <button onClick={() => setForm({ ...BOŞ_FORM })} style={{
          background: '#1d4ed8', color: '#fff', border: 'none', borderRadius: 8,
          padding: '10px 20px', cursor: 'pointer', fontWeight: 600, fontSize: 14,
        }}>+ Değerlendirme Ekle</button>
      </div>

      {/* ÖZET KARTLAR */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(6, 1fr)', gap: 12, marginBottom: 20 }}>
        <div style={{ background: '#f9fafb', borderRadius: 10, padding: '12px 16px', textAlign: 'center', border: '1px solid #e5e7eb' }}>
          <div style={{ fontSize: 11, color: '#6b7280' }}>Toplam</div>
          <div style={{ fontSize: 24, fontWeight: 700, color: '#374151' }}>{istatistik.toplam || 0}</div>
        </div>
        <div style={{ background: '#f9fafb', borderRadius: 10, padding: '12px 16px', textAlign: 'center', border: '1px solid #e5e7eb' }}>
          <div style={{ fontSize: 11, color: '#6b7280' }}>Ort. Puan</div>
          <div style={{ fontSize: 24, fontWeight: 700, color: '#374151' }}>{istatistik.ort || '—'}</div>
        </div>
        {Object.entries(SONUC).map(([k, v]) => (
          <div key={k} style={{ background: v.bg, borderRadius: 10, padding: '12px 16px', textAlign: 'center', border: `1px solid ${v.renk}20` }}>
            <div style={{ fontSize: 11, color: v.renk }}>{v.label}</div>
            <div style={{ fontSize: 22, fontWeight: 700, color: v.renk }}>{istatistik.dist?.[k] || 0}</div>
            <div style={{ fontSize: 10, color: v.renk }}>{v.min}–{v.max} puan</div>
          </div>
        ))}
      </div>

      {/* FİLTRELER */}
      <div style={{ display: 'flex', gap: 10, marginBottom: 16 }}>
        <select value={filtre.personel_id} onChange={e => filtreDegistir('personel_id', e.target.value)} style={{ ...selectSt, maxWidth: 280 }}>
          <option value="">Tüm Personel</option>
          {personeller.map(p => <option key={p.id} value={p.id}>{p.ad} {p.soyad} ({p.sicil_no})</option>)}
        </select>
        <input type="number" value={filtre.yil} onChange={e => filtreDegistir('yil', e.target.value)}
          style={selectSt} placeholder="Yıl" />
      </div>

      {/* LİSTE */}
      <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e5e7eb', overflow: 'hidden' }}>
        {liste.length === 0 ? (
          <div style={{ padding: 40, textAlign: 'center', color: '#9ca3af' }}>Değerlendirme kaydı bulunamadı.</div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead>
              <tr style={{ background: '#f9fafb', borderBottom: '1px solid #e5e7eb' }}>
                {['Personel', 'Yıl', 'Dönem', 'Meslek', 'İş Kal.', 'Verimli.', 'Uyum', 'Davranış', 'TOPLAM', 'Sonuç', 'Değerlendiren', ''].map(h => (
                  <th key={h} style={{ padding: '9px 10px', textAlign: 'left', fontWeight: 600, color: '#374151', fontSize: 11 }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {liste.map((pf, i) => {
                const s = SONUC[pf.sonuc] || { label: pf.sonuc, renk: '#374151', bg: '#f3f4f6' };
                return (
                  <tr key={pf.id} style={{ borderBottom: '1px solid #f3f4f6', background: i % 2 === 0 ? '#fff' : '#fafafa' }}>
                    <td style={{ padding: '8px 10px', fontWeight: 600 }}>{pf.personel_adi || `#${pf.personel_id}`}</td>
                    <td style={{ padding: '8px 10px', textAlign: 'center', fontFamily: 'monospace' }}>{pf.yil}</td>
                    <td style={{ padding: '8px 10px', textAlign: 'center', color: '#6b7280' }}>{pf.donem || '—'}</td>
                    {['meslek_bilgisi', 'is_kalitesi', 'verimlilik', 'uyum', 'davranis'].map(k => (
                      <td key={k} style={{ padding: '8px 10px', textAlign: 'center', fontFamily: 'monospace' }}>
                        <span style={{ color: (pf[k] || 0) >= 16 ? '#065f46' : (pf[k] || 0) >= 12 ? '#92400e' : '#991b1b', fontWeight: 600 }}>
                          {pf[k] ?? '—'}
                        </span>
                        <span style={{ color: '#9ca3af', fontSize: 10 }}>/20</span>
                      </td>
                    ))}
                    <td style={{ padding: '8px 10px', textAlign: 'center' }}>
                      <span style={{ fontWeight: 800, fontSize: 15, color: s.renk }}>{pf.toplam_puan?.toFixed(0)}</span>
                    </td>
                    <td style={{ padding: '8px 10px' }}>
                      <span style={{ background: s.bg, color: s.renk, fontSize: 11, fontWeight: 700, padding: '2px 8px', borderRadius: 6 }}>{s.label}</span>
                      {pf.itiraz_var && <span style={{ marginLeft: 4, fontSize: 10, color: '#991b1b', fontWeight: 700 }}>İTİRAZ</span>}
                    </td>
                    <td style={{ padding: '8px 10px', color: '#6b7280', fontSize: 12 }}>{pf.degerlendiren_adi || '—'}</td>
                    <td style={{ padding: '8px 10px' }}>
                      <button onClick={() => setForm({ ...pf })} style={kücükBtnSt}>Düzenle</button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>

      {/* FORM MODALI */}
      {form && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ background: '#fff', borderRadius: 14, padding: 28, width: 640, maxHeight: '92vh', overflow: 'auto' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
              <h3 style={{ margin: 0, fontSize: 18, fontWeight: 700 }}>Performans Değerlendirme Formu</h3>
              <button onClick={() => setForm(null)} style={{ background: 'none', border: 'none', fontSize: 18, cursor: 'pointer', color: '#9ca3af' }}>✕</button>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12, marginBottom: 18 }}>
              <div style={{ gridColumn: '1/3' }}>
                <label style={etiketSt}>Personel *</label>
                <select value={form.personel_id} onChange={e => setForm({ ...form, personel_id: e.target.value })} style={selectSt}>
                  <option value="">Seçiniz</option>
                  {personeller.map(p => <option key={p.id} value={p.id}>{p.ad} {p.soyad} ({p.sicil_no})</option>)}
                </select>
              </div>
              <div>
                <label style={etiketSt}>Yıl</label>
                <input type="number" value={form.yil} onChange={e => setForm({ ...form, yil: e.target.value })} style={inputSt} />
              </div>
              <div>
                <label style={etiketSt}>Dönem</label>
                <select value={form.donem} onChange={e => setForm({ ...form, donem: e.target.value })} style={selectSt}>
                  <option value="">Tam Yıl</option>
                  <option value="I">I. Dönem (Ocak–Haziran)</option>
                  <option value="II">II. Dönem (Temmuz–Aralık)</option>
                </select>
              </div>
              <div style={{ gridColumn: '2/4' }}>
                <label style={etiketSt}>Değerlendiren Adı</label>
                <input value={form.degerlendiren_adi} onChange={e => setForm({ ...form, degerlendiren_adi: e.target.value })} style={inputSt} />
              </div>
            </div>

            {/* PUAN ALANLARI */}
            <div style={{ background: '#f8fafc', borderRadius: 10, padding: 16, marginBottom: 16 }}>
              <div style={{ fontSize: 13, fontWeight: 700, color: '#374151', marginBottom: 12 }}>Değerlendirme Kriterleri (her kriter max 20 puan)</div>
              {PUAN_ALANLARI.map(alan => {
                const puan = Number(form[alan.key]) || 0;
                const yuzde = (puan / alan.max) * 100;
                return (
                  <div key={alan.key} style={{ marginBottom: 14 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
                      <div>
                        <span style={{ fontSize: 13, fontWeight: 600, color: '#374151' }}>{alan.label}</span>
                        <span style={{ fontSize: 11, color: '#9ca3af', marginLeft: 6 }}>{alan.aciklama}</span>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                        <input type="number" min={0} max={alan.max} value={form[alan.key]} onChange={e => setForm({ ...form, [alan.key]: e.target.value })}
                          style={{ ...inputSt, width: 60, textAlign: 'center', padding: '4px 6px' }} />
                        <span style={{ fontSize: 12, color: '#6b7280' }}>/{alan.max}</span>
                      </div>
                    </div>
                    <div style={{ background: '#e5e7eb', borderRadius: 999, height: 6, overflow: 'hidden' }}>
                      <div style={{ width: `${yuzde}%`, height: '100%', borderRadius: 999, transition: 'width 0.2s',
                        background: yuzde >= 80 ? '#065f46' : yuzde >= 60 ? '#d97706' : '#991b1b' }} />
                    </div>
                  </div>
                );
              })}

              {/* TOPLAM */}
              <div style={{ borderTop: '2px solid #e5e7eb', paddingTop: 12, marginTop: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontWeight: 700, fontSize: 15, color: '#374151' }}>TOPLAM PUAN</span>
                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                  <span style={{ fontSize: 28, fontWeight: 800, color: SONUC[sonucOtomatik]?.renk }}>{toplamPuan}</span>
                  <span style={{ background: SONUC[sonucOtomatik]?.bg, color: SONUC[sonucOtomatik]?.renk, fontWeight: 700, fontSize: 14, padding: '4px 14px', borderRadius: 8 }}>
                    {SONUC[sonucOtomatik]?.label}
                  </span>
                </div>
              </div>
            </div>

            <div style={{ marginBottom: 12 }}>
              <label style={etiketSt}>Değerlendirme Notu</label>
              <textarea value={form.degerlendirme_notu} onChange={e => setForm({ ...form, degerlendirme_notu: e.target.value })} style={{ ...inputSt, height: 70, resize: 'vertical' }} />
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 }}>
              <input type="checkbox" id="itiraz" checked={!!form.itiraz_var} onChange={e => setForm({ ...form, itiraz_var: e.target.checked })} />
              <label htmlFor="itiraz" style={{ fontSize: 13, color: '#374151' }}>İtiraz var</label>
            </div>
            {form.itiraz_var && (
              <div style={{ marginBottom: 12 }}>
                <label style={etiketSt}>İtiraz Notu</label>
                <textarea value={form.itiraz_notu} onChange={e => setForm({ ...form, itiraz_notu: e.target.value })} style={{ ...inputSt, height: 60, resize: 'vertical' }} />
              </div>
            )}

            <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 20 }}>
              <button onClick={() => setForm(null)} style={{ padding: '9px 20px', border: '1px solid #d1d5db', borderRadius: 8, background: '#f3f4f6', color: '#374151', cursor: 'pointer', fontWeight: 600 }}>İptal</button>
              <button onClick={kaydet} style={{ padding: '9px 20px', border: 'none', borderRadius: 8, background: '#1d4ed8', color: '#fff', cursor: 'pointer', fontWeight: 600 }}>Kaydet</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const etiketSt: React.CSSProperties = { display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4 };
const inputSt: React.CSSProperties = { width: '100%', padding: '7px 10px', border: '1px solid #d1d5db', borderRadius: 7, fontSize: 13, boxSizing: 'border-box' };
const selectSt: React.CSSProperties = { ...inputSt, background: '#fff' };
const kücükBtnSt: React.CSSProperties = { background: 'none', border: '1px solid #d1d5db', borderRadius: 6, padding: '3px 10px', cursor: 'pointer', fontSize: 12, color: '#374151' };
